import { Component } from '@angular/core';

@Component({
  selector: 'app-aml-policy',
  templateUrl: './aml-policy.component.html',
  styleUrl: './aml-policy.component.css',
})
export class AmlPolicyComponent {
  lastUpdated: string = 'March 2026';
  effectiveDate: string = '25-04-2025';
}
